(ns manage.adset-decision-tree-page.tree-generation-ocp.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Step$default" :as Step]
            ["@mui/material/StepLabel$default" :as StepLabel]
            ["@mui/material/Stepper$default" :as Stepper]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.ocp.view :refer [defocp ocp]]
            [manage.adset-decision-tree-page.tree-generation-ocp.classification
             :refer [classification]]
            [manage.adset-decision-tree-page.tree-generation-ocp.hook :as h]
            [manage.adset-decision-tree-page.tree-generation-ocp.value-mapping
             :refer [value-mapping]]
            [manage.adset-decision-tree-page.view.context :as context]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(def steps
  [{:label "Strategy classification"}
   {:label "Value mapping"}])

(defui ^:memo stepper [{:keys [active-step]}]
  ($ Stepper {:activeStep active-step
              :alternativeLabel true}
     (for [{:keys [label]} steps]
       ($ Step {:key label}
          ($ StepLabel label)))))

(defui footer-buttons [{:keys [on-previous on-next]}]
  ($ Stack {:direction "row"
            :justifyContent "flex-end"
            :gap 1}
     ($ Button {:on-click (if on-previous
                            on-previous
                            #(rf/dispatch [:ocp/close]))}
        (if on-previous "Back" "Cancel"))
     ($ Button {:variant "contained"
                :on-click on-next}
        "Next")))

(defui content [{:keys [be-classification be-value-mapping mappings]}]
  (let [[active-step set-active-step] (uix/use-state 0)
        [selected-column set-selected-column] (uix/use-state nil)
        {:keys [handleSubmit] :as classification-form-control}
        (h/use-classification-form-state be-classification)

        classified-columns (h/use-classified-columns classification-form-control)
        value-mapping-form-control (h/use-value-mapping-form-control
                                    classification-form-control
                                    be-value-mapping)
        save-targeting-config (h/use-save-targeting-config classified-columns
                                                           value-mapping-form-control
                                                           set-selected-column
                                                           mappings)
        first-step-submit (uix/use-memo #(handleSubmit (fn [] (set-active-step 1)))
                                        [handleSubmit])
        set-next-step (uix/use-callback
                       #(if (= active-step 0)
                          (first-step-submit)
                          (save-targeting-config))
                       [active-step save-targeting-config first-step-submit])]
    ($ Stack {:direction "column"
              :spacing 3
              :sx #js {:height "100%"}}
       ($ stepper {:active-step active-step})
       ($ Divider)
       ($ Box {:sx #js {:overflowY "auto"
                        :flexGrow 1}}
          (case active-step
            0 ($ classification {:classification-form-control classification-form-control})
            1 ($ value-mapping {:classification-form-control classification-form-control
                                :classified-columns classified-columns
                                :value-mapping-form-control value-mapping-form-control
                                :selected-column selected-column
                                :set-selected-column set-selected-column})))
       ($ Divider)
       ($ footer-buttons {:on-next set-next-step
                          :on-previous (when (pos? active-step)
                                         #(set-active-step dec))}))))

(defui tree-generation-ocp []
  (let [be-values (h/use-be-default-value)]
    ($ ocp {:title "Generate decision tree"}
       (if be-values
         ($ content be-values)
         ($ Stack
            {:height "100%"
             :alignItems "center"
             :justifyContent "center"}
            ($ CircularProgress))))))

(defocp ocp-view ::ocp {:width "60%"} []
  ($ context/with-decision-tree-context
     ($ tree-generation-ocp)))

(defmodal save-error-modal :tree-generation-ocp/save-error-modal []
  ($ modal-v2
     {:title "Feed Setup Incomplete"
      :icon ($ SvgIcon {:color "warning"}
               ($ AlertIcon))
      :footer ($ Stack {:direction "row" :gap 1}
                 ($ Button {:variant "text"
                            :sx #js {:color "text.primary"}
                            :onClick #(rf/dispatch [:modal/close])}
                    "Cancel"))}
     ($ Stack {:sx #js {:width "450px"}}
        ($ :p "Your feed configuration isn’t finished yet. Complete the setup to generate your strategy."))))
